<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


// PRODUCT ACCORDION -- START

document.addEventListener("DOMContentLoaded", function () {
    const firstAccordionItemHeader = document.querySelector(
      ".product_accordion_header"
    );
    const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;
    firstAccordionItemHeader.parentNode.classList.add("active");
    // Open the first accordion item by default
    // firstAccordionItemHeader.classList.add("active");
    // firstAccordionItemBody.style.maxHeight =
    //   firstAccordionItemBody.scrollHeight + "px";

    const accordionItemHeaders = document.querySelectorAll(
      ".product_accordion_header"
    );
    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(
          ".product_accordion_header.active"
        );
        if (
          currentlyActiveAccordionItemHeader &&
          currentlyActiveAccordionItemHeader !== accordionItemHeader
        ) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.parentNode.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        accordionItemHeader.parentNode.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  });

// PRODUCT ACCORDION -- END